import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import "../../index.css";
import { useSnackbar } from "notistack";
import axiosInstance from "../../axiosInstance";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const UserAcquisitionLogs = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = React.useState([]);
  const [showSiteData, setShowSiteData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  async function fetchData() {
    setLoading(true);
    try {
      let response = await axiosInstance.get(`/api/admin/user-acqusition-logs`);

      setData(response.data.data);
      // console.log(response.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="w-full p-4 flex flex-row">
      {loading ? (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4, gap: 1, width: "100%" }}>
          <CircularProgress />
          <span style={{ color: "#666" }}>Loading user logs...</span>
        </Box>
      ) : data.length === 0 ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4, color: "#666", width: "100%" }}>
          No user acquisition logs found.
        </Box>
      ) : (
      <>
      <div className=" bg-white w-7/12 overflow-x-auto h-[calc(100vh-100px)]">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow className="p-2">
                <TableCell>User email</TableCell>
                <TableCell>Source</TableCell>
                <TableCell>Created On</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, idx: any) => {
                const date = new Date(row.createdOn);
                return (
                  <TableRow
                    key={idx}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row" className="break-all">
                      {row.email}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.googleSource === true
                        ? "Google"
                        : row.linkedInSource === true
                        ? "LinkedIn"
                        : "-"}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {date.toLocaleString()}
                    </TableCell>

                    <TableCell align="right">
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          sx={{
                            textTransform: "none",
                          }}
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setShowSiteData(row.sites);
                          }}
                        >
                          View Sites
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="w-5/12 pl-4">
        {showSiteData &&
          showSiteData.map((ee: any) => {
            const _date = new Date(ee.updatedAt);
            const { siteUrl, subDomain } = ee;
            let updatedUrl = siteUrl;
            // if (siteUrl && subDomain) {
            //   const parts = siteUrl.split(".");
            //   if (parts.length >= 1 && parts[0] !== subDomain) {
            //     parts[0] = subDomain;
            //     updatedUrl = parts.join(".");
            //   }
            // }
            return (
              <div className="bg-white p-2 m-1 rounded-lg" key={ee.siteId}>
                <div className="flex flex-row">
                  <span className="pr-2">Site Name: </span>
                  <span>{ee.siteName}</span>
                </div>
                <div className="flex flex-row">
                  <span className="pr-2">Last modified On: </span>
                  <span>{_date.toLocaleString()}</span>
                </div>
                <div className="flex flex-row">
                  <span className="pr-2">Publish Status: </span>
                  <span>{ee.isPublished ? "true" : "false"}</span>
                </div>
                {ee.source &&
                <div className="flex flex-row">
                  <span className="pr-2">AI Source: </span>
                  <span>{ee.source}</span>
                </div>
                }
                <div className="flex flex-row">
                  <span className="pr-2">Site URL: </span>
                  <a href={`https://${updatedUrl}`} target="_blank">
                    {updatedUrl}
                  </a>
                </div>
                <div className="flex flex-row">
                  <span className="pr-2">Editor URL: </span>
                  <a
                    href={`${process.env.EDITOR_ENDPOINT}/${ee.siteId}`}
                    target="_blank"
                  >
                    {`${process.env.EDITOR_ENDPOINT}/${ee.siteId}`}
                  </a>
                </div>
              </div>
            );
          })}
      </div>
      </>
      )}
    </div>
  );
};

export default UserAcquisitionLogs;
